import type { SVGProps } from 'react';

const SvgWebhook = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M3.06 31.64h15.62a2.73 2.73 0 0 0 2.73-2.73v-8.79h7.53a2.74 2.74 0 0 0 2.73-2.74V3.09A2.73 2.73 0 0 0 28.94.36H14.49a2.73 2.73 0 0 0-2.73 2.73v8.13h-8.7A2.73 2.73 0 0 0 .33 14v15a2.73 2.73 0 0 0 2.73 2.64M1.83 14a1.23 1.23 0 0 1 1.23-1.23h8.7v2.93h1.5V3.09a1.23 1.23 0 0 1 1.23-1.23h14.45a1.23 1.23 0 0 1 1.23 1.23v14.29a1.24 1.24 0 0 1-1.23 1.24h-12v1.5h3v8.79a1.23 1.23 0 0 1-1.23 1.23H3.06a1.23 1.23 0 0 1-1.23-1.23Z" />
      <path d="M9.47 27a3.79 3.79 0 0 0 3.79-3.78 3.7 3.7 0 0 0-.72-2.2l7.07-7.61a3.79 3.79 0 1 0-1.06-1.07L11.44 20a3.7 3.7 0 0 0-2-.57 3.79 3.79 0 1 0 0 7.57ZM21.71 8a2.29 2.29 0 1 1-2.28 2.29A2.28 2.28 0 0 1 21.71 8M9.47 20.9a2.29 2.29 0 1 1-2.29 2.29 2.29 2.29 0 0 1 2.29-2.29" />
    </g>
  </svg>
);

export default SvgWebhook;
